import { Outlet } from 'react-router-dom';
import CustomizationLayout from '@/app/(dashboard)/customization/layout';
export function CustomizationLayoutWrapper() {
  return (
    <CustomizationLayout>
      <Outlet />
    </CustomizationLayout>
  );
}
